// extracted by mini-css-extract-plugin
module.exports = {"icon":"Alerts_icon__qhB9F","alerts":"Alerts_alerts__igjpx","alert":"Alerts_alert__sV_MH","alertContent":"Alerts_alertContent__tEC0_"};